import { render, staticRenderFns } from "./GroupItem.vue?vue&type=template&id=5a4b0ff4&scoped=true&"
import script from "./GroupItem.vue?vue&type=script&lang=js&"
export * from "./GroupItem.vue?vue&type=script&lang=js&"
import style0 from "./GroupItem.vue?vue&type=style&index=0&id=5a4b0ff4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4b0ff4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a4b0ff4')) {
      api.createRecord('5a4b0ff4', component.options)
    } else {
      api.reload('5a4b0ff4', component.options)
    }
    module.hot.accept("./GroupItem.vue?vue&type=template&id=5a4b0ff4&scoped=true&", function () {
      api.rerender('5a4b0ff4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/atm/components/cards/GroupItem.vue"
export default component.exports